import React, { useState, useEffect } from "react";
import { Link, Redirect, useHistory } from "react-router-dom";

const AuthContext = React.createContext({
  isLoggedIn: false,
  onLogout: () => {},
  onLoging: () => {},
  darkModeHandler: () => {},
  darkMode: false,
});

export const AuthContextProvider = (props) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const history = useHistory();

  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    const storedUserLoggedInInformation = localStorage.getItem("isLoggedIn");

    if (storedUserLoggedInInformation === "1") {
      setIsLoggedIn(true);
    }
  }, []);


  const logoutHandler = () => {
    localStorage.removeItem("isLoggedIn");
    localStorage.setItem("Authtoken", "");
    localStorage.setItem("userInfo", "");
    localStorage.removeItem("PermissionDetails");
    setIsLoggedIn(false);
  };

  const loginHandler = () => {
    localStorage.setItem("isLoggedIn", "1");
    setIsLoggedIn(true);
  };

  const darkModeHandler = (value) => {
    setDarkMode(value);
  };

  return (
    <AuthContext.Provider
      value={{
        isLoggedIn: isLoggedIn,
        onLogout: logoutHandler,
        onLoging: loginHandler,
        darkModeHandler: darkModeHandler,
        darkMode: darkMode,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
